import React from "react";
import { BsFillPeopleFill } from "react-icons/bs";
import { FaUserEdit } from "react-icons/fa";
import { FiLock } from "react-icons/fi";
import {
  IoMdInformationCircleOutline,
  IoMdNotifications,
} from "react-icons/io";
import { IoLinkOutline } from "react-icons/io5";
import { MdLanguage } from "react-icons/md";

export default function Menu() {
  const menuItems = [
    {
      label: "Edit Profile",
      icon: <FaUserEdit size={35} color="#999999" />,
      link: "edit-profile",
      includeId: true,
      dimension: { w: "35.38px", h: "32px" },
    },

    {
      label: "Manage Password",
      icon: <FiLock size={35} color="#999999" />,
      link: "manage-password",
      dimension: { w: "35.71px", h: "32px" },
    },
    {
      label: "Notification Settings",
      icon: <IoMdNotifications size={35} color="#999999" />,
      link: "notification-settings",
      dimension: { w: "25px", h: "31.25px" },
    },
    {
      label: "Language",
      icon: <MdLanguage size={35} color="#999999" />,
      link: "language",
      dimension: { w: "32px", h: "32px" },
    },
    {
      label: "About Us",
      icon: <IoMdInformationCircleOutline size={35} color="#999999" />,
      link: "about-us",
      dimension: { w: "32px", h: "32px" },
    },
  ];
  return menuItems;
}
